<template>
<div class="chapter">
<div class="inner_page">
<div class="image_wrap">
<p class="image"><a id="page_8"></a><img alt="image" class="horizontal" src="images/f0008-01.jpg"/></p>
</div>
<div class="image_wrap">
<p class="image"><a id="page_9"></a><img alt="image" class="horizontal" src="images/f0009-01.jpg"/></p>
</div>
<h1><a id="ch1"></a>On Giving Thanks</h1>
<p class="centert"><span class="dropcap">H</span>anging on the wall in my small study is a beautiful piece of calligraphy. In the center is one word, <em>Joy</em>, and on either side is a passage from the Book of Isaiah:</p>
<p class="centert"><em>You shall go out with joy and be led forth with peace:<br/>The mountains and the hills will break forth in singing<br/>And the trees of the field shall clap their hands</em>.</p>
<p class="centert">I live in Vermont, where it is easy to imagine the mountains and hills bursting out in song and the maple tree, much taller than my house, clapping her ancient hands in delight. In my long life, I have known a lot of joy, and what I have come to believe is that joy is the twin sister of gratitude. I am most joyful when I am most grateful. When I was a child, we sang this grace before Sunday morning breakfast:</p>
<p class="centert"><em>Thank you for the world so sweet,<br/>Thank you for the food we eat,<br/>Thank you for the birds that sing,<br/>Thank you, God, for everything</em>.</p>
<p class="centert">And I am thankful, three times every day, for good food to eat and a warm home. I am grateful for the beauty of each season, from the brightness of summer to the snows of winter. I am grateful for the many years I have been given to enjoy this good earth—for my loving family, my crazy dog, my church, my friends, and for work I love to do that has given me friends all around the world. I am truly blessed. But my childhood blessing reminds me to be thankful for everything—not just those occasions when I am happy, but the hard times—the disappointments, failures, and losses that brought me to a new place where I could grow in wisdom and compassion and, yes, real joy. This is a book about giving thanks—thanks for everything. The prayers on these pages come from many ages and multiple traditions, but I think you will find, as I have, a kinship with these voices and inspiration from the pictures that accompany them. I know words and art will help me consider all the blessings I have been given, remembering the prayer of seventeenth-century poet George Herbert, and making it my own:</p>
<p class="centert"><em>Thou that hast given so much to me, give one thing more—a grateful heart</em>.</p>
<p class="centert"><span class="small">KATHERINE PATERSON</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07chater01.vue?c7fb4e1a